import { useQuery } from 'react-query';
import { getWebAccountInfoUsingPOST } from 'services/web-account-controller';

export function useGetWebAccountInfoUsingPOST(enabled?: { enabled: boolean }) {
    return useQuery(
        ['/rest/i18n/web/account/info'],
        async () => {
            const data = await getWebAccountInfoUsingPOST();
            return data.data;
        },
        { refetchOnMount: false, ...enabled },
    );
}
